import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../../Components/Shared/Buttons/BtnSubmit';
import {Container} from 'reactstrap';
import SwiperCore, {Navigation, Pagination, Scrollbar, A11y} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {isMobile, isTablet} from 'react-device-detect';
import SubscriberCard from '../SubscriberCard/SubscriberCard';
import {setPageBackFromOtp, goToPage} from '../../fundialSlice';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const ManagementEntrance = (props) => {
  const [isOneSubscriberUnregistered, setIsOneSubscriberUnregistered] = useState(false);

  useEffect(() => {
    if (props.subscribers && props.subscribers.length == 1 && props.subscribers[0].fundialSubscriberStatus == 'UNREGISTERED') {
      setIsOneSubscriberUnregistered(true);
    }
  }, [props.subscribers]);

  function redirectToOtpPage() {
    props.setPageBackFromOtp({pageBackFromOtp: 'personalAreaPage'});
    props.goToPage({page: 'otpPage'});
  }

  return (
    <div className='management-entrance'>
      {isOneSubscriberUnregistered ? (
        <div className='join'>
          <div className='title'>
            <h2>מה נשמע?</h2>
            <p>הצטרפו והשמיעו לחברים את השירים שאתם אוהבים</p>
          </div>
          <div className='content'>
            <SubscriberCard subscriber={props.subscribers[0]} />
          </div>
        </div>
      ) : (
        <>
          {props.subscribers && props.subscribers.length > 0 ? (
            <div className='subscribers'>
              <div className='subscribers-header'>
                <h2 className='title'>
                  נהלו
                  <br />
                  <span className='sub-title'>את רשימת השירים</span>
                </h2>
              </div>
              <div className={`swiper-wrapper ${props.subscribers.length == 1 ? 'one-slider' : ''}`}>
                <Swiper
                  enabled={(props.subscribers.length > 3).toString()}
                  navigation={props.subscribers.length > 3}
                  slidesPerView={isMobile ? 1 : isTablet ? 2 : 3}
                  scrollbar={{draggable: true}}
                  onSwiper={(swiper) => console.log(swiper)}
                  onSlideChange={() => console.log('slide change')}>
                  {props.subscribers.map((subscriber, i) => (
                    <SwiperSlide key={i}>
                      <SubscriberCard subscriber={subscriber} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          ) : (
            <div className='nonsubscribers'>
              <h2 className='title'>
                נהלו
                <br />
                <span className='sub-title'>את רשימת השירים</span>
              </h2>
              <p>כאן תוכלו להחליף שירים שהורדתם, למחוק להגדיר אנשי קשר לשירים שלכם</p>
              <div className='management-btn-wrapper'>
                <BtnSubmit
                  onclick={() => {
                    redirectToOtpPage();
                  }}
                  text='לאיזור הניהול'
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscribers: state.fundialPage.subscribers,
  };
};

const mapDispatchToProps = {
  goToPage,
  setPageBackFromOtp,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagementEntrance);
